/** Snake locomotion is grounded; launch momentum is the only source of airborne travel. */
export const SNAKE_BITE_RANGE = 0.55;
export const SNAKE_SPEED = 4.5;
export const GIANT_SNAKE_SPEED = 3.5;
export const SNAKE_HALF_HEIGHT = 0.1;
export const GIANT_SNAKE_HALF_HEIGHT = 0.18;
